package com.trevorwiebe.timesheet.loads.domain.usecases

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.loads.domain.LoadsRepository

/** Deletes a load document. */
class DeleteLoad(
    private val loadsRepository: LoadsRepository,
) {
    suspend fun invoke(loadId: String): TSResult =
        loadsRepository.deleteLoad(loadId)
}
